import React from "react";

import { AdvertImage, Usage } from "@at/design-system-patterns";

interface GalleryModalSliderImageProps {
  src: string;
  alt?: string;
  shouldLazyLoad: boolean;
}

export const GalleryModalSliderImage = ({
  src,
  alt,
  shouldLazyLoad,
}: GalleryModalSliderImageProps) => {
  return (
    <AdvertImage
      {...{
        alt,
        src,
        usage: Usage.Full,
        loading: shouldLazyLoad ? "lazy" : "eager",
        decoding: shouldLazyLoad ? "async" : "sync",
      }}
    />
  );
};
